export default __webpack_public_path__ + "bfx/static/media/icon-POPULAR_SEARCHES.716a1812.svg";